import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule as AngularFormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { AutocompleteComponent, CheckboxComponent, HelpTextComponent, UpperCaseInputDirective } from './public-api';
import { TrimInputDirective } from './directives/trim/input-trim.directive';
import { UpperCaseTrimInputDirective } from './directives/uppercase-trim/input-uppercase-trim.directive';

@NgModule({
  declarations: [
    AutocompleteComponent,
    HelpTextComponent,
    UpperCaseInputDirective,
    TrimInputDirective,
    UpperCaseTrimInputDirective,
    CheckboxComponent,
  ],
  imports: [
    CommonModule,
    AngularFormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    PopoverModule,
  ],
  exports: [
    AutocompleteComponent,
    HelpTextComponent,
    UpperCaseInputDirective,
    TrimInputDirective,
    UpperCaseTrimInputDirective,
    CheckboxComponent
  ]
})
export class FormsModule { }
